module.exports = __webpack_public_path__ + "img/horizontal_3_6_5012.da71dbb3.png";